// extracted by mini-css-extract-plugin
export default {"c-loading-spinner":"_LTB_7","c-loading-spinner__spinner":"_u9uh8"};